module.exports = __webpack_public_path__ + "static/img/reimaging-onboarding-data04.9f4d85b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/reimaging-onboarding-data04.png
// module id = 11N3
// module chunks = 1